import React from 'react';
import { motion } from 'motion/react';
import AccountSettings from './sections/AccountSettings';
import ProfileSettings from './sections/ProfileSettings';
import SecuritySettings from './sections/SecuritySettings';
import AppearanceSettings from './sections/AppearanceSettings';
import NotificationSettings from './sections/NotificationSettings';
import EnergySettings from './sections/EnergySettings';
import SystemSettings from './sections/SystemSettings';
import IntegrationSettings from './sections/IntegrationSettings';
import BillingSettings from './sections/BillingSettings';

interface SettingsContentProps {
  activeTab: string;
}

const SettingsContent: React.FC<SettingsContentProps> = ({ activeTab }) => {
  const renderContent = () => {
    switch (activeTab) {
      case 'account':
        return <AccountSettings />;
      case 'profile':
        return <ProfileSettings />;
      case 'security':
        return <SecuritySettings />;
      case 'appearance':
        return <AppearanceSettings />;
      case 'notifications':
        return <NotificationSettings />;
      case 'energy':
        return <EnergySettings />;
      case 'system':
        return <SystemSettings />;
      case 'integrations':
        return <IntegrationSettings />;
      case 'billing':
        return <BillingSettings />;
      default:
        return <AccountSettings />;
    }
  };

  return (
    <div className="flex-1 rounded-2xl border border-gray-100/50 bg-white/80 p-8 shadow-lg backdrop-blur-sm">
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {renderContent()}
      </motion.div>
    </div>
  );
};

export default SettingsContent;
